import React from "react";
import { getBrandedTheme } from "./.themes";
import { Theme } from "@material-ui/core/styles";
import { Route } from "react-router";
import { CHECKOUT_ROUTE, DONE_ROUTE, BASE_ROUTE } from "./store";
import { BrandsEnum } from "./enums";

import * as WebshopPages from "./pages/webshop";

export interface BrandedConfiguration {
  Theme: Theme;
  Routes: React.ReactNode | React.ReactNode[];
}

function getBrandedRoutes(brand: BrandsEnum): React.ReactNode | React.ReactNode[] {
  switch (brand) {
    case BrandsEnum.Polestar:
    case BrandsEnum.PolestarForetag:
    case BrandsEnum.PolestarMO:
    case BrandsEnum.PolestarForetagMO:
    case BrandsEnum.Audi:
    case BrandsEnum.Bmw:
    case BrandsEnum.BmwMO:
    case BrandsEnum.Volvia:
    case BrandsEnum.VolviaForetag:
    case BrandsEnum.Nissan:
    case BrandsEnum.Volkswagen:
    case BrandsEnum.Volkswagentransportbilar:
    case BrandsEnum.Kia:
    case BrandsEnum.Cupra:
    case BrandsEnum.Renault:
    case BrandsEnum.MG:
    case BrandsEnum.Porsche:
    case BrandsEnum.Mercedes:
    case BrandsEnum.Skoda:
    case BrandsEnum.Ford:
    case BrandsEnum.IfRullaVidare:
    case BrandsEnum.IfRullaVidareMO:
    case BrandsEnum.Seat:
    case BrandsEnum.Opel:
    case BrandsEnum.Mini:
    case BrandsEnum.Dacia:
      return (
        <React.Fragment>
          <Route path={CHECKOUT_ROUTE} component={WebshopPages.Checkout} />
          <Route path={DONE_ROUTE} component={WebshopPages.Done} />
          <Route exact path={BASE_ROUTE} component={WebshopPages.App} />
        </React.Fragment>
      );
  }

  throw new Error(`No matching routes found for brand '${brand}'!`);
}

export function getBrandedConfiguration(brand: BrandsEnum): BrandedConfiguration {
  return {
    Theme: getBrandedTheme(brand),
    Routes: getBrandedRoutes(brand),
  } as BrandedConfiguration;
}
